import { SELLER_PORTAL_ACCESS_TOKEN } from '@/_constants';
import { validateToken } from '@/_utils/auth-v3/validate-token';
import { asyncSingleton } from '@/_utils/auth-v3/async-singleton';

const verifyExistingTokenRaw = async () => {
  const accessToken = localStorage.getItem(SELLER_PORTAL_ACCESS_TOKEN) || '';

  if (!accessToken) {
    throw new Error();
  }

  try {
    await validateToken(accessToken);
  } catch (error) {
    localStorage.removeItem(SELLER_PORTAL_ACCESS_TOKEN);

    throw error;
  }

  return true;
};

export const verifyExistingToken = () =>
  asyncSingleton('verifyExistingToken', verifyExistingTokenRaw);
